import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow" light>
          <Container>
            <NavbarBrand tag={Link} to="/">
              <img src="/logo-hor.png" alt="Tuff Shed" className="full-logo"/>
              <img src="/logo.png" alt="Tuff Shed" className="square-logo"/>
              <span className="site-title">IT Trust Center</span>
            </NavbarBrand>
            {/* <NavbarToggler onClick={this.toggleNavbar} className="mr-2" /> */}
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <NavLink className="text-dark" href="https://itsupport.tuffshed.com">Support Portal</NavLink>
                </NavItem>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
